query company($id: String!) {
  company(id: $id) {
    id
    avv {
      acceptedAt
      acceptedByUserId
    }
  }
}
